import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_2 = {
  for: "name",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_3 = { class: "w-full flex-column items-space-between mt-2" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  for: "name",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  for: "name",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  for: "name",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  id: "date_last_menstruation",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_20 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { value: "1° Trimestre" }
const _hoisted_26 = { value: "2° Trimestre" }
const _hoisted_27 = { value: "3° Trimestre" }
const _hoisted_28 = { value: "Sconosciuta" }
const _hoisted_29 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_30 = {
  key: 0,
  class: "form-group"
}
const _hoisted_31 = {
  id: "nursing_mother",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_32 = { class: "col-lg-4" }
const _hoisted_33 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = {
  id: "reaction",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_36 = { class: "col-lg-8" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  id: "date_reaction",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_41 = { class: "col-lg-8" }
const _hoisted_42 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = {
  id: "severity",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = {
  selected: "",
  hidden: "",
  value: ""
}
const _hoisted_47 = { value: "Non grave" }
const _hoisted_48 = { value: "Ricovero in ospedale" }
const _hoisted_49 = { value: "Pericolo di vita" }
const _hoisted_50 = { value: "Invalidità permanente" }
const _hoisted_51 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = {
  id: "reaction_duration",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_58 = { class: "col-lg-8" }
const _hoisted_59 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = {
  id: "drugs_to_treat_reaction",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_62 = { class: "col-lg-8" }
const _hoisted_63 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = {
  id: "reaction_now",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_66 = { class: "col-lg-4" }
const _hoisted_67 = {
  selected: "",
  hidden: "",
  value: ""
}
const _hoisted_68 = { value: "Risolta" }
const _hoisted_69 = { value: "Risolta con conseguenze" }
const _hoisted_70 = { value: "Migliorata" }
const _hoisted_71 = { value: "Non ancora risolta" }
const _hoisted_72 = { value: "Non so" }
const _hoisted_73 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = {
  id: "batch_number",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_76 = { class: "col-lg-8" }
const _hoisted_77 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = {
  id: "prescribed_by_doctor",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_80 = { class: "col-lg-4" }
const _hoisted_81 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = {
  id: "care_provider_warned",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_84 = { class: "col-lg-4" }
const _hoisted_85 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = {
  id: "reason",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_88 = { class: "col-lg-8" }
const _hoisted_89 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_90 = { class: "form-group" }
const _hoisted_91 = {
  id: "adverse_reaction_drug_suspended",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_92 = { class: "col-lg-4" }
const _hoisted_93 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_94 = { class: "form-group" }
const _hoisted_95 = {
  id: "first_assumption_date",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_96 = { class: "col-lg-8" }
const _hoisted_97 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = {
  id: "last_assumption_date",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_100 = { class: "col-lg-8" }
const _hoisted_101 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_102 = { class: "form-group" }
const _hoisted_103 = {
  id: "how_many_times_day",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_104 = { class: "col-lg-8" }
const _hoisted_105 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = {
  id: "how_drug_taken",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_108 = { class: "col-lg-8" }
const _hoisted_109 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_110 = { class: "form-group" }
const _hoisted_111 = {
  id: "drug_already_used",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_112 = { class: "col-lg-4" }
const _hoisted_113 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = {
  id: "same_reaction",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_116 = { class: "col-lg-4" }
const _hoisted_117 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_118 = { class: "form-group" }
const _hoisted_119 = {
  id: "other_drugs_used",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_120 = { class: "col-lg-8" }
const _hoisted_121 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_122 = { class: "w-full flex-column items-space-between mt-2" }
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = {
  id: "other_diseases",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_125 = { class: "col-lg-8" }
const _hoisted_126 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_127 = { class: "form-group" }
const _hoisted_128 = { class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_129 = { class: "form-group" }
const _hoisted_130 = {
  id: "name_care_provider",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_131 = { class: "col-lg-8" }
const _hoisted_132 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_133 = { class: "form-group" }
const _hoisted_134 = {
  id: "contactable_care_provider",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_135 = { class: "col-lg-4" }
const _hoisted_136 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_137 = { class: "form-group" }
const _hoisted_138 = {
  id: "address_care_provider",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_139 = { class: "col-lg-8" }
const _hoisted_140 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_141 = { class: "form-group" }
const _hoisted_142 = {
  id: "phone_care_provider",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_143 = { class: "col-lg-8" }
const _hoisted_144 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_145 = { class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_146 = { class: "form-group" }
const _hoisted_147 = {
  id: "address_patient",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_148 = { class: "col-lg-8" }
const _hoisted_149 = ["value"]
const _hoisted_150 = { class: "form-group" }
const _hoisted_151 = {
  id: "phone_patient",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_152 = { class: "col-lg-8" }
const _hoisted_153 = ["value"]
const _hoisted_154 = { class: "form-group" }
const _hoisted_155 = {
  id: "email_patient",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_156 = { class: "col-lg-8" }
const _hoisted_157 = ["value"]
const _hoisted_158 = { class: "flex justify-between mt-2" }

import { Modal, Input } from "flowbite-vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";
import { AdverseReactions } from "../../../../EshJSLib/models/patient";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { initFlowbite } from "flowbite";
import { Tabs, Tab } from 'flowbite-vue'





export default /*#__PURE__*/_defineComponent({
  __name: 'farmaciModalAdverseReactions',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const activeTab = ref(null);
const store = patientStore();
const { patient } = storeToRefs(store);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
const modalType = ref<"confirm" | "alert">("confirm");

const mandatoryFields = ['id_structure_pharmacovigilance', 'date_last_menstruation','pregnancy', 'nursing_mother','reaction', 'date_reaction',
'severity','reaction_affect','reaction_duration','drug_to_treat_reaction','reaction_now','batch_number','prescribed_by_doctor',
'care_provider_warned','reason','adverse_reaction_drug_suspended','first_assumption_date','last_assumption_date','how_many_times_day','how_drug_taken',
'drug_already_used','same_reaction','other_drugs_used','other_diseases','name_care_provider','contactable_care_provider','address_care_provider',
'phone_care_provider'];

let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
let adverseNew = ref({} as AdverseReactions);
let isOpen = ref(false);
let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";


onMounted(() => {
    errors.value = [];
    initFlowbite();
});

function openModal(message: string, rowData: AdverseReactions): Promise<boolean> {
    errors.value = [];
    adverseNew.value = rowData
    alertConfirmMessage.value = message;
    showConfirm.value = true;
    return new Promise((resolve) => {
        resolvePromise = resolve;
    });

}

function handleUserInput(value: boolean) {


    if (!resolvePromise) return;
    resolvePromise(value);
    showConfirm.value = false;
}

function validateFields(): boolean {
  let hasError = false;
  errors.value = [];
 
  mandatoryFields.forEach((field, index) => {
   
    if (!adverseNew.value[field]) {
      hasError = true;
    
      errors.value.push(errorMessage);
    }
    else {
      errors.value.push("");

    }
  });

  if (new Date(adverseNew.value.first_assumption_date) > new Date(adverseNew.value.last_assumption_date)) {
    errors.value[17] = "Data inizio maggiore di data fine";
 
    hasError = true;
  }

  if (hasError) {
    return false;
  }
  return true;
}

function saveAdverseReactions() {

    if( !validateFields()) {
        return;
    }

    alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then((userInput) => {

        if (userInput) {
            showConfirm.value = false;
            if (!resolvePromise) return;
            resolvePromise(true);
        }
    });

}

function closeModal() {
    showConfirm.value = false
    if (!resolvePromise) return;
    resolvePromise(false);
    emit("cancel");

}

__expose({ openModal });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showConfirm.value)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          onClose: _cache[37] || (_cache[37] = ($event: any) => (handleUserInput(false)))
        }, {
          body: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Reazioni avverse")), 1)
              ]),
              _createVNode(_unref(Tabs), {
                style: {"height":"300px","overflow-y":"scroll"},
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((activeTab).value = $event)),
                class: "p-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Tab), {
                    name: "info",
                    title: _ctx.$t('Informazioni sul paziente')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Regione * ")), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("select", {
                              id: "id_asl_structure",
                              name: "id_asl_structure",
                              style: {"width":"100%"},
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(adverseNew).id_structure_pharmacovigilance) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).pharmacovigilance_structures, (item, key) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: _unref(patient).pharmacovigilance_structures[key].id,
                                  key: key
                                }, _toDisplayString(item.struttura), 9, _hoisted_7))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _unref(adverseNew).id_structure_pharmacovigilance]
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(errors)[0]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Peso')), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("input", {
                              id: "patient_weight",
                              name: "patient_weight",
                              type: "numeric",
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                              value: _unref(patient).tbl_parametri_vitalis[0].parametro_peso
                            }, null, 8, _hoisted_12)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Altezza')), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("input", {
                              id: "patient_height",
                              name: "patient_height",
                              type: "numeric",
                              class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                              value: _unref(patient).tbl_parametri_vitalis[0].parametro_altezza
                            }, null, 8, _hoisted_16)
                          ])
                        ]),
                        (_unref(patient).paziente_sesso == 'female')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('Data ultima mestruazione')), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "date_last_menstruation",
                                    name: "date_last_menstruation",
                                    type: "date",
                                    class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(adverseNew).date_last_menstruation) = $event))
                                  }, null, 512), [
                                    [_vModelText, _unref(adverseNew).date_last_menstruation]
                                  ]),
                                  _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(errors)[1]), 1)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('Inserire Trimestre Gravidanza')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).tbl_gravidanze, (item, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      value: key,
                                      key: key
                                    }, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _withDirectives(_createElementVNode("select", {
                                          id: "pregnancy",
                                          name: "pregnancy",
                                          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(adverseNew).pregnancy) = $event))
                                        }, [
                                          _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('1° Trimestre')), 1),
                                          _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('2° Trimestre')), 1),
                                          _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('3° Trimestre')), 1),
                                          _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t('Sconosciuta')), 1)
                                        ], 512), [
                                          [_vModelSelect, _unref(adverseNew).pregnancy]
                                        ]),
                                        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(errors)[2]), 1)
                                      ]),
                                      (item.fine_gravidanza != null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('Allattamento')), 1),
                                            _createElementVNode("div", _hoisted_32, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                name: "nursing_mother",
                                                id: "nursing_mother",
                                                value: "1",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(adverseNew).nursing_mother) = $event))
                                              }, null, 512), [
                                                [_vModelRadio, _unref(adverseNew).nursing_mother]
                                              ]),
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                                              _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                name: "nursing_mother",
                                                id: "nursing_mother",
                                                value: "0",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(adverseNew).nursing_mother) = $event))
                                              }, null, 512), [
                                                [_vModelRadio, _unref(adverseNew).nursing_mother]
                                              ]),
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')) + " ", 1),
                                              _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(errors)[3]), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_23))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Reazione avversa",
                    title: _ctx.$t('Reazione avversa del farmaco')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('Reazione avversa osservata')), 1),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("input", {
                            id: "reaction",
                            name: "reaction",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            value: _unref(adverseNew).reaction
                          }, null, 8, _hoisted_37),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(errors)[4]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('Data inizio sintomi')), 1),
                        _createElementVNode("div", _hoisted_41, [
                          _withDirectives(_createElementVNode("input", {
                            id: "date_reaction",
                            name: "date_reaction",
                            type: "date",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(adverseNew).date_reaction) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).date_reaction]
                          ]),
                          _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(errors)[5]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('Gravità')), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("select", {
                            id: "severity",
                            name: "severity",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(adverseNew).severity) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t('Selezionare')), 1),
                            _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.$t('Non grave')), 1),
                            _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t('Ricovero in ospedale')), 1),
                            _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t('Pericolo di vita')), 1),
                            _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t('Invalidità permanente')), 1)
                          ], 512), [
                            [_vModelSelect, _unref(adverseNew).severity]
                          ]),
                          _createElementVNode("p", _hoisted_51, _toDisplayString(_unref(errors)[6]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('Quanto ha influito la reazione sulla qualità di vita?')), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "reaction_affect",
                          name: "reaction_affext",
                          class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(adverseNew).reaction_affect) = $event))
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                            return _createElementVNode("option", {
                              key: i,
                              value: i
                            }, _toDisplayString(i), 9, _hoisted_54)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, _unref(adverseNew).reaction_affect]
                        ]),
                        _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(errors)[7]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('Quanto è durata ? ')), 1),
                        _createElementVNode("div", _hoisted_58, [
                          _withDirectives(_createElementVNode("input", {
                            id: "reaction_duration",
                            name: "reaction_duration",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(adverseNew).reaction_duration) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).reaction_duration]
                          ]),
                          _createElementVNode("p", _hoisted_59, _toDisplayString(_unref(errors)[8]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('Ha utilizzato dei farmaci o altro per curare la reazione ? ')), 1),
                        _createElementVNode("div", _hoisted_62, [
                          _withDirectives(_createElementVNode("input", {
                            id: "drugs_to_treat_reaction",
                            name: "drugs_to_treat_reaction",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(adverseNew).drugs_to_treat_reaction) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).drugs_to_treat_reaction]
                          ]),
                          _createElementVNode("p", _hoisted_63, _toDisplayString(_unref(errors)[9]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('Adesso la reazione avversa è ? ')), 1),
                        _createElementVNode("div", _hoisted_66, [
                          _withDirectives(_createElementVNode("select", {
                            id: "reaction_now",
                            name: "reaction_now",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(adverseNew).reaction_now) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t('Selezionare')), 1),
                            _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.$t('Risolta')), 1),
                            _createElementVNode("option", _hoisted_69, _toDisplayString(_ctx.$t('Risolta con conseguenze')), 1),
                            _createElementVNode("option", _hoisted_70, _toDisplayString(_ctx.$t('Migliorata')), 1),
                            _createElementVNode("option", _hoisted_71, _toDisplayString(_ctx.$t('Non ancora risolta')), 1),
                            _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('Non so')), 1)
                          ], 512), [
                            [_vModelSelect, _unref(adverseNew).reaction_now]
                          ]),
                          _createElementVNode("p", _hoisted_73, _toDisplayString(_unref(errors)[10]), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Altri dettagli",
                    title: _ctx.$t('Altri dettagli')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('N. Lotto del farmaco (se conosciuto)')), 1),
                        _createElementVNode("div", _hoisted_76, [
                          _withDirectives(_createElementVNode("input", {
                            id: "batch_number",
                            name: "batch_number",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(adverseNew).batch_number) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).batch_number]
                          ]),
                          _createElementVNode("p", _hoisted_77, _toDisplayString(_unref(errors)[11]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('Prescritto dal medico?')), 1),
                        _createElementVNode("div", _hoisted_80, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "prescribed_by_doctor",
                            id: "prescribed_by_doctor",
                            value: "1",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(adverseNew).prescribed_by_doctor) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).prescribed_by_doctor]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "prescribed_by_doctor",
                            id: "prescribed_by_doctor",
                            value: "0",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(adverseNew).prescribed_by_doctor) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).prescribed_by_doctor]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_81, _toDisplayString(_unref(errors)[12]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('Il medico curante è stato informato di questa reazione ? ')), 1),
                        _createElementVNode("div", _hoisted_84, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "care_provider_warned",
                            id: "care_provider_warned",
                            value: "1",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(adverseNew).care_provider_warned) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).care_provider_warned]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "care_provider_warned",
                            id: "care_provider_warned",
                            value: "0",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(adverseNew).care_provider_warned) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).care_provider_warned]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_85, _toDisplayString(_unref(errors)[13]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('Per quale motivo ? ')), 1),
                        _createElementVNode("div", _hoisted_88, [
                          _withDirectives(_createElementVNode("input", {
                            id: "reason",
                            name: "reason",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(adverseNew).reason) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).reason]
                          ]),
                          _createElementVNode("p", _hoisted_89, _toDisplayString(_unref(errors)[14]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('Il farmaco è stato sospeso a causa della reazione avversa ? ')), 1),
                        _createElementVNode("div", _hoisted_92, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "adverse_reaction_drug_suspended",
                            id: "adverse_reaction_drug_suspended",
                            value: "1",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(adverseNew).adverse_reaction_drug_suspended) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).adverse_reaction_drug_suspended]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "adverse_reaction_drug_suspended",
                            id: "adverse_reaction_drug_suspended",
                            value: "0",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(adverseNew).adverse_reaction_drug_suspended) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).adverse_reaction_drug_suspended]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_93, _toDisplayString(_unref(errors)[15]), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Consumazione",
                    title: _ctx.$t('Consumazione')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('Data inizio assunzione')), 1),
                        _createElementVNode("div", _hoisted_96, [
                          _withDirectives(_createElementVNode("input", {
                            id: "first_assumption_date",
                            name: "first_assumption_date",
                            type: "date",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(adverseNew).first_assumption_date) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).first_assumption_date]
                          ]),
                          _createElementVNode("p", _hoisted_97, _toDisplayString(_unref(errors)[16]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('Data fine assunzione')), 1),
                        _createElementVNode("div", _hoisted_100, [
                          _withDirectives(_createElementVNode("input", {
                            id: "last_assumption_date",
                            name: "last_assumption_date",
                            type: "date",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(adverseNew).last_assumption_date) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).last_assumption_date]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_101, _toDisplayString(_unref(errors)[17]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t('Quante volte al giorno ? ')), 1),
                        _createElementVNode("div", _hoisted_104, [
                          _withDirectives(_createElementVNode("input", {
                            id: "how_many_times_day",
                            name: "how_many_times_day",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(adverseNew).how_many_times_day) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).how_many_times_day]
                          ]),
                          _createElementVNode("p", _hoisted_105, _toDisplayString(_unref(errors)[18]), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('Come (per bocca, iniezione, uso cutaneo, ecc) ? ')), 1),
                        _createElementVNode("div", _hoisted_108, [
                          _withDirectives(_createElementVNode("input", {
                            id: "how_drug_taken",
                            name: "how_drug_taken",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(adverseNew).how_drug_taken) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).how_drug_taken]
                          ]),
                          _createElementVNode("p", _hoisted_109, _toDisplayString(_unref(errors)[19]), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Informazioni passate",
                    title: _ctx.$t('Informazioni passate')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('Il farmaco era stato preso in passato ? ')), 1),
                        _createElementVNode("div", _hoisted_112, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "drug_already_used",
                            id: "drug_already_used",
                            value: "1",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(adverseNew).drug_already_used) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).drug_already_used]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "drug_already_used",
                            id: "drug_already_used",
                            value: "0",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(adverseNew).drug_already_used) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).drug_already_used]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_113, _toDisplayString(_unref(errors)[20]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('Era avvenuta la stessa reazione ? ')), 1),
                        _createElementVNode("div", _hoisted_116, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "same_reaction",
                            id: "same_reaction",
                            value: "1",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(adverseNew).same_reaction) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).same_reaction]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "same_reaction",
                            id: "same_reaction",
                            value: "0",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(adverseNew).same_reaction) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).same_reaction]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_117, _toDisplayString(_unref(errors)[21]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('Oltre al farmaco indicato in precedenza riportare eventuali altri farmaci o prodotti(es.: integratori, erbe medicinali) assunti contemporaneamente: ')), 1),
                        _createElementVNode("div", _hoisted_120, [
                          _withDirectives(_createElementVNode("input", {
                            id: "other_drugs_used",
                            name: "other_drugs_used",
                            type: "text",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(adverseNew).other_drugs_used) = $event)),
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).other_drugs_used]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_121, _toDisplayString(_unref(errors)[22]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t('Indicare eventuali altre malattie del paziente (per esempio allergie, malattie croniche)')), 1),
                          _createElementVNode("div", _hoisted_125, [
                            _withDirectives(_createElementVNode("input", {
                              id: "other_diseases",
                              name: "other_diseases",
                              type: "text",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(adverseNew).other_diseases) = $event)),
                              class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            }, null, 512), [
                              [_vModelText, _unref(adverseNew).other_diseases]
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_126, _toDisplayString(_unref(errors)[23]), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Care provider",
                    title: _ctx.$t('Care provider')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t('Se sì, potrebbe indicare le seguenti informazioni relative al suo medico curante: ')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t('Nome e Cognome Care Provider: ')), 1),
                        _createElementVNode("div", _hoisted_131, [
                          _withDirectives(_createElementVNode("input", {
                            id: "name_care_provider",
                            name: "name_care_provider",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(adverseNew).name_care_provider) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).name_care_provider]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_132, _toDisplayString(_unref(errors)[24]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.$t('Nel caso in cui fosse necessario approfondire il suo caso, possiamo contattare il suo medico curante ? ')), 1),
                        _createElementVNode("div", _hoisted_135, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "contactable_care_provider",
                            id: "contactable_care_provider",
                            value: "1",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(adverseNew).contactable_care_provider) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).contactable_care_provider]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('SI')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "contactable_care_provider",
                            id: "contactable_care_provider",
                            value: "0",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(adverseNew).contactable_care_provider) = $event))
                          }, null, 512), [
                            [_vModelRadio, _unref(adverseNew).contactable_care_provider]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('NO')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_136, _toDisplayString(_unref(errors)[25]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t('Indirizzo Care Provider')), 1),
                        _createElementVNode("div", _hoisted_139, [
                          _withDirectives(_createElementVNode("input", {
                            id: "address_care_provider",
                            name: "address_care_provider",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(adverseNew).address_care_provider) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).address_care_provider]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_140, _toDisplayString(_unref(errors)[26]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t('Numero di telefono Care Provider')), 1),
                        _createElementVNode("div", _hoisted_143, [
                          _withDirectives(_createElementVNode("input", {
                            id: "phone_care_provider",
                            name: "phone_care_provider",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(adverseNew).phone_care_provider) = $event))
                          }, null, 512), [
                            [_vModelText, _unref(adverseNew).phone_care_provider]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_144, _toDisplayString(_unref(errors)[27]), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_unref(Tab), {
                    name: "Patient card",
                    title: _ctx.$t('Patient card')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.$t('Informazioni sul compilatore della scheda:')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t('Indirizzo')), 1),
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("input", {
                            id: "address_patient",
                            name: "address_patient",
                            type: "text",
                            value: _unref(adverseNew).address_patient,
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          }, null, 8, _hoisted_149)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t('Telefono')), 1),
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("input", {
                            id: "phone_patient",
                            name: "phone_patient",
                            type: "text",
                            value: _unref(adverseNew).phone_patient,
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          }, null, 8, _hoisted_153)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.$t('Email')), 1),
                        _createElementVNode("div", _hoisted_156, [
                          _createElementVNode("input", {
                            id: "email_patient",
                            name: "email_patient",
                            type: "text",
                            class: "form-control bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                            value: _unref(patient).paziente_email
                          }, null, 8, _hoisted_157)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("button", {
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (closeModal())),
                  type: "button",
                  class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                }, _toDisplayString(_ctx.$t("Annulla")), 1),
                _createElementVNode("button", {
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (saveAdverseReactions())),
                  type: "button",
                  class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                }, _toDisplayString(_ctx.$t("Procedi")), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512)
  ], 64))
}
}

})